import GoogleCalendarExample from './GoogleCalendarExample';

const Main = () => {
    return (
        <main>
            <GoogleCalendarExample />
        </main>
    )
}

export default Main